<template>
  <div class="faq">
    <SiteHeader/>
    <div class="faq__hero">
      <div class="container">
        <h1>FAQ</h1>
      </div>
    </div>
    <div class="faq__main">
      <div class="container">
        <h3>FAQ title</h3>
        <p>FAQ text goes here</p>
        <h3>FAQ title</h3>
        <p>FAQ text goes here</p>
        <h3>FAQ title</h3>
        <p>FAQ text goes here</p>
        <h3>FAQ title</h3>
        <p>FAQ text goes here</p>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
import SiteHeader from '@/components/SiteHeader'
import Footer from '@/components/Footer'

export default {
  name: 'faq',
  components: {
    SiteHeader,
    Footer
  }
}
</script>

<style scoped lang="scss">
.faq {
  .container {
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
  }
  &__hero {
    background-color: $primary;
    // height: 100vh;
    .container {
      margin: 0 auto;
      max-width: 600px;
      padding: 80px 40px 120px 40px;
      text-align: center;

      h1 {
        color: white;
        font-family: Raleway, sans-serif;
        font-weight: 300;
        margin-bottom: 40px;
        line-height: 1.3;
        strong {
          font-weight: 700;
        }
      }
      p {
        color: white;
        font-family: Raleway, sans-serif;
        font-weight: 500;
      }
    }
  }
  &__main {
    padding: 80px 40px;
  }
}
</style>